var exports = {
  "WB": "PersonalNotesWelcomeSection.module__welcomeSection___b2JsU0",
  "H": "PersonalNotesWelcomeSection.module__avatarContainer___b2JsU0",
  "oJ": "PersonalNotesWelcomeSection.module__avatarBackground___b2JsU0",
  "my": "PersonalNotesWelcomeSection.module__avatar___b2JsU0",
  "DD": "PersonalNotesWelcomeSection.module__title___b2JsU0",
  "fF": "PersonalNotesWelcomeSection.module__dividerContainer___b2JsU0",
  "K8": "PersonalNotesWelcomeSection.module__dividerSvg___b2JsU0",
  "h_": "PersonalNotesWelcomeSection.module__description___b2JsU0",
};

module.exports = exports;
